import { RootState } from "store/rootReducer";
import { TClassRoom } from "./type";

export const selectClassroom: (state: RootState) => TClassRoom = (state) =>
  state.classroom;
